import dayjs from "dayjs";
import { Language } from "../const";
import {
  type ADVERTORIALS_SECTOR,
  CATEGORIES,
  type MEDIA_TYPE,
  type PublicationType,
} from "../../const";

export const advertorialsListLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/news-and-videos/advertorials-en.json",
  [Language.TC]: "/data/tc/news-and-videos/advertorials-tc.json",
  [Language.SC]: "/data/sc/news-and-videos/advertorials-sc.json",
};

export function getAdvertorialsData(
  advertorials_json: any[],
  language: Language
): PublicationType[] {
  if (language === Language.EN)
    return advertorials_json?.map((item) => {
      const date = dayjs(item?.date) ?? "";
      const year = date?.year();

      return {
        title: item?.date ?? "",
        date: "",
        link: item?.url ?? "",
        mediaType: item?.type as MEDIA_TYPE,
        sector: item?.cate as ADVERTORIALS_SECTOR[],
        category: [CATEGORIES.ADVERTORIALS],
        yearRange: [year, year],
      };
    });
  // for TC/SC
  return advertorials_json?.map((item) => {
    const date = dayjs(item?.date) ?? "";
    const year = date?.year();

    return {
      title: dayjs(date).format("YYYY年M月D日"),
      date: "",
      link: item?.url ?? "",
      mediaType: item?.type as MEDIA_TYPE,
      sector: item?.cate as ADVERTORIALS_SECTOR[],
      category: [CATEGORIES.ADVERTORIALS],
      yearRange: [year, year],
    };
  });
}
